module.exports = __webpack_public_path__ + "static/assets/85b64e3c61fcd80ff1ee38fa30592aba.png";